// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--7-1!../node_modules/less-loader/dist/cjs.js??ref--7-2!./index.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../node_modules/vue-style-loader/lib/addStylesClient.js")("4a7c1e93", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/index.less
// module id = 599
// module chunks = 8